var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-block-list-placeholder"},[_c('span',[_vm._v("[block] "+_vm._s(_vm.alias))]),_vm._v(" "),(_vm.content)?_c('pre',{staticClass:"c-block-list-placeholder__content"},[_vm._v(_vm._s(_vm.content))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }